export default __webpack_public_path__ + "static/Picto_bat_new-2f7f6eec60ebc028a79c005c8e365171.jpg";